module.exports = __webpack_public_path__ + "static/media/LONG_TERM_RESIDENT.9fa84ec4.svg";